import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/forget',
    name: 'forget',
    meta: {
      title: '忘记密码'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "forget" */ '../views/Forget.vue')
  },
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '首页'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue')
  },
  {
    path: '/choose-goods',
    name: 'choose-goods',
    meta: {
      title: '选择商品'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "choose-goods" */ '../views/ChooseGoods.vue')
  },
  {
    path: '/custom',
    name: 'custom',
    meta: {
      title: '定制'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "custom" */ '../views/Custom.vue')
  },
  {
    path: '/order',
    name: 'order',
    meta: {
      title: '订单一览',
      cache: true
    },
    component: () => import(/* webpackChunkName: "order" */ '../views/Order.vue')
  },
  {
    path: '/order-detail',
    name: 'order-detail',
    meta: {
      title: '订单详情'
    },
    component: () => import(/* webpackChunkName: "order-detail" */ '../views/OrderDetail.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
